export const EXPIRED_URL_PARAM = 'expired'
export const LOGGED_IN_ELSEWHERE_PARAM = 'logged-in-elsewhere'
export const LOGIN_PATH = '/login'
export const LOGOUT_PATH = '/logout'
export const FORGOT_PASSWORD_PATH = '/forgot-password'
export const COMING_SOON = '/coming-soon'
export const STUDENT_SIGN_UP = '/students'
export const LOOKUP_URL_PARAM = 'lookup'
export const PLACE_ID_PARAM = 'pid'
export const SIGNUP_PATH = '/signup'
export const SUBSCRIBE_PATH = '/subscribe'
export const TRIAL_EXPIRED_PATH = '/expired/trial'
export const PREMIUM_EXPIRED_PATH = '/expired/premium'

export const ONE_PIXEL_BLANK_SRC =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII='

export const PLACEHOLDER_IMG_SRC = '/report-placeholder.png'

export const ZOOM_LIMIT_MAP_EDITOR = 15.5
